import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'react-bootstrap';
import moment from 'moment';
import $ from 'jquery';
import OverviewPriceContainer from '../overviewSearchBar/overviewPriceContainer/OverviewPriceContainer';
import OverviewBreadcrumb from './overviewBreadcrumb/OverviewBreadcrumb';

import './OverviewSearchBar.css';

var I18n = require('i18n-react').default;
const DATE_FORMAT = 'D MMM YYYY';

const propTypes = {
  origin: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  departureDate: PropTypes.string.isRequired,
  returnDate: PropTypes.string,
  totalAdults: PropTypes.number,
  totalKids: PropTypes.number,
  totalBabys: PropTypes.number,
  alterSearchCallback: PropTypes.func.isRequired,
  alterFlightOverviewPrice: PropTypes.bool.isRequired,
  history: PropTypes.object,
  stepsBreadcrumb: PropTypes.arrayOf(PropTypes.string),
  actualStepBreadcrumb: PropTypes.string,
  renderOpen: PropTypes.bool
};

const defaultProps = {
  returnDate: null,
  totalAdults: Number(0),
  totalKids: Number(0),
  totalBabys: Number(0),
  history: {
    location: {}
  },
  stepsBreadcrumb: [],
  actualStepBreadcrumb: '',
  renderOpen: false
};

class OverviewSearchBar extends React.Component {
  constructor() {
    super();

    this.state = {};

    this.goBack = this.goBack.bind(this);
  }

  componentDidMount() {
    $(window).scroll(() => {
      const minTop = $(window).width() < 768 ? 48 : 64;

      if ($(window).scrollTop() >= minTop) {
        $('#containerHeaderBar').addClass('fixed');
        $('.collapsedFixedTitle').addClass('fixedFlighTtitle');
      } else {
        $('#containerHeaderBar').removeClass('fixed');
        $('.collapsedFixedTitle').removeClass('fixedFlighTtitle');
      }
    });
  }

  componentWillUnmount() {
    $(window).unbind('scroll');
  }

  goBack() {
    if (this.props.history.location.pathname.indexOf('flights') !== -1) {
      this.props.alterSearchCallback();
    } else {
      this.props.history.goBack();
    }
  }

  renderBackButton() {
    return (
      <Col
        xs={2}
        smHidden
        mdHidden
        lgHidden
        id="overviewSearchBarMobileAlterSearchId"
        className="OverviewSearchBar--columnIcon alignMiddle"
        onClick={this.goBack}>
        <i className="icon-caret-down OverviewSearchBar--icon" />
      </Col>
    );
  }

  renderOriginDestination() {
    return (
      <Col xs={6} sm={2} md={2} lg={2} className="originDestinationRow alignMiddle">
        {this.renderOriginDestinationIndicator()}
      </Col>
    );
  }

  renderOriginDestinationIndicator() {
    return (
      <Row className="originDestinationIndicator">
        <Col id="overviewSearchOriginFlightLbl" xs={5}>
          {this.props.origin}
        </Col>
        <Col xs={2} className="flightIcon" />
        <Col id="overviewSearchDestinationFlightLbl" xs={5}>
          {this.props.destination}
        </Col>
      </Row>
    );
  }

  renderDatesAndPassenger() {
    if (this.props.returnDate) {
      return (
        <Col xsHidden smHidden md={5} lg={5} className="datePassengerRoundTripRow">
          <Row className="groupRow">
            <Col md={7} lg={6} className="datesRow alignMiddle">
              {this.renderAllDates()}
            </Col>
            <Col md={5} lg={6} className="passengersRow alignMiddle">
              {this.renderPassengers()}
            </Col>
          </Row>
        </Col>
      );
    } else {
      return (
        <Col xsHidden smHidden md={4} lg={4} className="datePassengerOneWayRow">
          <Row className="groupRow">
            <Col md={5} lg={5} className="datesRow alignMiddle">
              {this.renderOnlyDepartureDate()}
            </Col>
            <Col md={7} lg={7} className="passengersRow alignMiddle">
              {this.renderPassengers()}
            </Col>
          </Row>
        </Col>
      );
    }
  }

  renderAllDates() {
    return (
      <Row className="datesAndPassengerRow border-left border-right">
        <Col md={6} className="title">
          {I18n.translate('components.overviewSearch.departure')}
        </Col>
        <Col md={6} className="title">
          {I18n.translate('components.overviewSearch.return')}
        </Col>
        <Col id="overviewSearchDepartureDateLbl" md={6} className="textTop">
          {moment(this.props.departureDate).format(DATE_FORMAT)}
        </Col>
        <Col id="overviewSearchReturnDateLbl" md={6} className="textTop">
          {moment(this.props.returnDate).format(DATE_FORMAT)}
        </Col>
      </Row>
    );
  }

  renderOnlyDepartureDate() {
    return (
      <Row className="datesAndPassengerRow border-left border-right">
        <Col sm={12} className="title">
          {I18n.translate('components.overviewSearch.departure')}
        </Col>
        <Col id="overviewSearchDepartureDateLbl" sm={12} className="textTop">
          {moment(this.props.departureDate).format(DATE_FORMAT)}
        </Col>
      </Row>
    );
  }

  renderPassengers() {
    return (
      <Row className="datesAndPassengerRow border-right">
        <Col sm={12} className="title">
          {I18n.translate('components.overviewSearch.passengers')}
        </Col>
        <Col sm={12} className="textTop">
          <span id="overviewSearchTotalAdultsLbl">
            {this.getTotalAdults(this.props.totalAdults)}
          </span>
          {this.props.totalKids > 0 && (
            <span id="overviewSearchTotalKidsLbl">{this.getTotalKids(this.props.totalKids)}</span>
          )}
          {this.props.totalBabys > 0 && (
            <span id="overviewSearchTotalBabysLbl">
              {this.getTotalBabys(this.props.totalBabys)}
            </span>
          )}
        </Col>
      </Row>
    );
  }

  renderAlterSearchButton() {
    return (
      <Col
        xsHidden
        md={2}
        mdOffset={0}
        lg={2}
        lgOffset={0}
        className="alterSearchRow no-padding alignMiddle">
        {this.renderButton()}
      </Col>
    );
  }

  renderOverviewPrice() {
    if (this.props.returnDate) {
      return (
        <Col xs={4} md={3} lg={3} className="overviewPrice">
          <OverviewPriceContainer
            quotationJourney={this.props.quotationJourney}
            alterFlight={this.props.alterFlightOverviewPrice}
            renderOpen={this.props.renderOpen}
          />
        </Col>
      );
    } else {
      return (
        <Col xs={4} md={4} lg={4} className="overviewPrice">
          <OverviewPriceContainer
            quotationJourney={this.props.quotationJourney}
            alterFlight={this.props.alterFlightOverviewPrice}
            renderOpen={this.props.renderOpen}
          />
        </Col>
      );
    }
  }

  renderButton() {
    return (
      <Button
        id="overviewSearchAlterSearchBtn"
        bsClass="small"
        className="alterSearchBtn"
        onClick={this.props.alterSearchCallback}>
        {I18n.translate('components.overviewSearch.alterSearchBtn')}
      </Button>
    );
  }

  getTotalAdults(total) {
    var text;
    if (total > 1) {
      text = `${total} ${I18n.translate('components.overviewSearch.adults')}${
        this.props.totalKids > 0 || this.props.totalBabys > 0 ? ', ' : ''
      }`;
    } else {
      text = `${total} ${I18n.translate('components.overviewSearch.adult')}${
        this.props.totalKids > 0 || this.props.totalBabys > 0 ? ', ' : ''
      }`;
    }
    return text;
  }

  getTotalKids(total) {
    var text;
    if (total > 1) {
      text = `${total} ${I18n.translate('components.overviewSearch.kids')}${
        this.props.totalBabys > 0 ? ', ' : ''
      }`;
    } else {
      text = `${total} ${I18n.translate('components.overviewSearch.kid')}${
        this.props.totalBabys > 0 ? ', ' : ''
      }`;
    }
    return text;
  }

  getTotalBabys(total) {
    var text;
    if (total > 1) {
      text = `${total} ${I18n.translate('components.overviewSearch.babys')}`;
    } else {
      text = `${total} ${I18n.translate('components.overviewSearch.baby')}`;
    }
    return text;
  }

  renderBreadcrumb() {
    return (
      <OverviewBreadcrumb
        id="overviewBreadcrumb"
        steps={this.props.stepsBreadcrumb}
        actual={this.props.actualStepBreadcrumb}
      />
    );
  }

  render() {
    return (
      <div id="containerHeaderBar" className="row-top">
        <Row id="headerBar">
          <Col xs={12} sm={12} md={12} lg={12} className="no-padding">
            <Row id="overviewSearchBar" className="OverviewSearchBar">
              <Col xs={12} sm={12} md={12} lg={12}>
                <Row className="groupRow">
                  {this.renderBackButton()}
                  {this.renderOriginDestination()}
                  {this.renderDatesAndPassenger()}
                  {this.renderAlterSearchButton()}
                  {this.renderOverviewPrice()}
                </Row>
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12} className="no-padding">
            {this.renderBreadcrumb()}
          </Col>
        </Row>
      </div>
    );
  }
}

OverviewSearchBar.propTypes = propTypes;
OverviewSearchBar.defaultProps = defaultProps;

export default OverviewSearchBar;



// WEBPACK FOOTER //
// ./src/components/overviewSearchBar/OverviewSearchBar.jsx